import api from "./axios";
import type { Category, EntryKind } from "@/types";

export const getCategories = (kind?: EntryKind) =>
  api
    .get<Category[]>("/categories", { params: kind ? { kind } : {} })
    .then((r) => r.data);

export const getCategory = (id: string) =>
  api.get<Category>(`/categories/${id}`).then((r) => r.data);

export const createCategory = (data: {
  name: string;
  description?: string;
  kind?: EntryKind;
}) => api.post<Category>("/categories", data).then((r) => r.data);

export const updateCategory = (
  id: string,
  data: { name?: string; description?: string },
) => api.patch<Category>(`/categories/${id}`, data).then((r) => r.data);

export const deleteCategory = (id: string) =>
  api.delete(`/categories/${id}`).then((r) => r.data);
